import React from 'react';

import { connect } from 'react-redux';

import { Select } from '@nerdwallet/currency';

import { REFINANCE } from '../../../lib/analytics-constants';
import { validationsSelector } from '../../../lib/selectors';
import { inputsSelector } from '../../../lib/selectors/refinance-calculator-selectors';
import {
  RefinanceInput,
  REFINANCE_GOAL_ANALYTICS_HASH_VALUE,
  INPUT_TRACKING_TYPES,
  inputOnChange,
} from '../../../lib/utils';
import { goals as RefinanceGoalOptions } from '../goals';

type OnChangeEvent = React.ChangeEvent<HTMLInputElement>;

const RefinanceGoalInput: React.FC<RefinanceInput> = ({
  inputs,
  dispatch,
  analytics,
  validations,
  label = '',
  className = '',
  tooltip = '',
  fullWidth,
}) => {
  const value = inputs?.refinanceGoal;
  const errorMessage = validations?.refinanceGoal?.[0];
  const error = Boolean(errorMessage);
  const analyticsEnabled = analytics && analytics?.enabled;
  const legacyAnalytics =
    analyticsEnabled && analytics?.payload?.legacy?.formName;
  const bedrockAnalytics =
    analyticsEnabled && analytics?.payload?.bedrock?.eventType;

  const onInputChange = (e: OnChangeEvent) => {
    let legacy;
    if (legacyAnalytics) {
      const legacyProps = analytics?.payload?.legacy;
      legacy = {
        ...legacyProps,
        fieldName: 'refinanceGoal',
        inputType: INPUT_TRACKING_TYPES.RANGE,
      };
    }

    let bedrock;
    if (bedrockAnalytics) {
      const bedrockProps = analytics?.payload?.bedrock;
      bedrock = {
        ...bedrockProps,
        valueFieldName: 'value_s',
        mapValue: (target: string) =>
          REFINANCE_GOAL_ANALYTICS_HASH_VALUE[target] || null,
      };
    }

    inputOnChange({
      event: e,
      dispatch,
      legacy,
      bedrock,
      fieldName: 'refinanceGoal',
      calculator: REFINANCE,
    });
  };

  return (
    <Select
      options={RefinanceGoalOptions}
      value={value}
      error={error}
      errorMessage={errorMessage}
      onChange={onInputChange}
      label={label}
      className={className}
      tooltip={tooltip}
      fullWidth={fullWidth}
    />
  );
};

const mapStateToProps = (state) => ({
  inputs: inputsSelector(state),
  validations: validationsSelector(state),
});

export default connect(mapStateToProps)(RefinanceGoalInput);
